'use client'

import { cn } from '@/lib/classNames'
import { NAVBAR_LINKS } from '@/lib/texts/header'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export function NavLinks() {
  const pathname = usePathname()

  return (
    <nav className="hidden md:ml-8 md:flex md:gap-8">
      {NAVBAR_LINKS.map(({ href, text }) => (
        <Link
          key={href}
          href={href}
          className="relative -mx-3 -my-2 rounded-lg px-3 py-2 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-100 hover:text-gray-900 dark:text-gray-200 dark:hover:bg-gray-900 dark:hover:text-white"
        >
          <span
            className={cn(
              'relative z-10 pb-0.5',
              pathname === href &&
                'border-b-2 border-gray-700 hover:border-gray-900 dark:border-gray-200 dark:hover:border-white'
            )}
          >
            {text}
          </span>
        </Link>
      ))}
    </nav>
  )
}
